import { render } from "./scaleIO.vue?vue&type=template&id=09788319"
import script from "./scaleIO.vue?vue&type=script&lang=js"
export * from "./scaleIO.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__